module.exports = __webpack_public_path__ + "media/components/images/QR_Code_Promo_Page-dadf84cdb9f36ae2b5f5b807ace9acbd.png";